export var TextureFormat;
(function (TextureFormat) {
    TextureFormat[TextureFormat["R8G8B8"] = 0] = "R8G8B8";
    TextureFormat[TextureFormat["R8G8B8A8"] = 1] = "R8G8B8A8";
    TextureFormat[TextureFormat["R5G6B5"] = 16] = "R5G6B5";
    TextureFormat[TextureFormat["Alpha8"] = 2] = "Alpha8";
    TextureFormat[TextureFormat["DXT1"] = 3] = "DXT1";
    TextureFormat[TextureFormat["DXT3"] = 29] = "DXT3";
    TextureFormat[TextureFormat["DXT5"] = 4] = "DXT5";
    TextureFormat[TextureFormat["ETC1RGB"] = 5] = "ETC1RGB";
    TextureFormat[TextureFormat["ETC2RGB"] = 6] = "ETC2RGB";
    TextureFormat[TextureFormat["ETC2RGBA"] = 7] = "ETC2RGBA";
    TextureFormat[TextureFormat["ETC2SRGB_Alpha8"] = 8] = "ETC2SRGB_Alpha8";
    TextureFormat[TextureFormat["ETC2SRGB"] = 28] = "ETC2SRGB";
    TextureFormat[TextureFormat["ETC2RGB_Alpha1"] = 32] = "ETC2RGB_Alpha1";
    TextureFormat[TextureFormat["ETC2SRGB_Alpha1"] = 33] = "ETC2SRGB_Alpha1";
    TextureFormat[TextureFormat["PVRTCRGB_2BPPV"] = 9] = "PVRTCRGB_2BPPV";
    TextureFormat[TextureFormat["PVRTCRGBA_2BPPV"] = 10] = "PVRTCRGBA_2BPPV";
    TextureFormat[TextureFormat["PVRTCRGB_4BPPV"] = 11] = "PVRTCRGB_4BPPV";
    TextureFormat[TextureFormat["PVRTCRGBA_4BPPV"] = 12] = "PVRTCRGBA_4BPPV";
    TextureFormat[TextureFormat["R32G32B32A32"] = 15] = "R32G32B32A32";
    TextureFormat[TextureFormat["R32G32B32"] = 30] = "R32G32B32";
    TextureFormat[TextureFormat["R16G16B16A16"] = 17] = "R16G16B16A16";
    TextureFormat[TextureFormat["R16G16B16"] = 31] = "R16G16B16";
    TextureFormat[TextureFormat["ASTC4x4"] = 18] = "ASTC4x4";
    TextureFormat[TextureFormat["ASTC4x4SRGB"] = 23] = "ASTC4x4SRGB";
    TextureFormat[TextureFormat["ASTC6x6"] = 19] = "ASTC6x6";
    TextureFormat[TextureFormat["ASTC6x6SRGB"] = 24] = "ASTC6x6SRGB";
    TextureFormat[TextureFormat["ASTC8x8"] = 20] = "ASTC8x8";
    TextureFormat[TextureFormat["ASTC8x8SRGB"] = 25] = "ASTC8x8SRGB";
    TextureFormat[TextureFormat["ASTC10x10"] = 21] = "ASTC10x10";
    TextureFormat[TextureFormat["ASTC10x10SRGB"] = 26] = "ASTC10x10SRGB";
    TextureFormat[TextureFormat["ASTC12x12"] = 22] = "ASTC12x12";
    TextureFormat[TextureFormat["ASTC12x12SRGB"] = 27] = "ASTC12x12SRGB";
    TextureFormat[TextureFormat["KTXTEXTURE"] = -1] = "KTXTEXTURE";
    TextureFormat[TextureFormat["PVRTEXTURE"] = -2] = "PVRTEXTURE";
})(TextureFormat || (TextureFormat = {}));
